/**
 * Nested CTA discriminant under conditional CTA `options[].cta` (YAML `go_to_page` / `display_message`).
 */

export const NESTED_CTA_TYPE_GO_TO_PAGE = "go_to_page" as const;
export const NESTED_CTA_TYPE_DISPLAY_MESSAGE = "display_message" as const;

export const NESTED_CTA_TYPES = [
  NESTED_CTA_TYPE_GO_TO_PAGE,
  NESTED_CTA_TYPE_DISPLAY_MESSAGE,
] as const;

export type NestedCtaType = (typeof NESTED_CTA_TYPES)[number];

export const isNestedCtaType = (value: string): value is NestedCtaType =>
  (NESTED_CTA_TYPES as readonly string[]).includes(value);
